import { render, staticRenderFns } from "./CustomSource.vue?vue&type=template&id=a1677bee&scoped=true&"
import script from "./CustomSource.vue?vue&type=script&lang=js&"
export * from "./CustomSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1677bee",
  null
  
)

export default component.exports